import styled from 'styled-components';

// Container Commands — flat (sem bg/borda; embedded em List que ja esta
// dentro de Section pai). Padding reduzido pra nao gastar viewport.
export const Container = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  padding: 8px var(--cco-pad) 14px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--cco-line);

  #comands {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
  }
`;

// Caption — rotulo discreto "Comandos" acima dos botoes de comando.
// Substitui o antigo Header (que tinha engrenagem PNG + cadeado/historico
// duplicados). A trava e o historico agora vivem no RailHead do List.
export const Caption = styled.div`
  color: var(--cco-ink-mute);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  margin-bottom: 4px;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Label = styled.label`
  font-size: ${(props) => (props.size ? props.size : '16px')};
  color: ${(props) => props.color};

  ${(props) => props.bold && 'font-weight: 900'};
  ${(props) =>
    props.clickable && 'cursor: pointer; :hover {text-decoration: underline;}'};
`;

export const ModalContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--cco-surface);
  padding: 50px 40px 40px;
  border-radius: 10px;

  #title {
    margin: 10px 0;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: var(--cco-soft-surface);
  cursor: pointer;
  transition: 0.2s all;

  color: var(--cco-ink-mute);
  font-size: 11px;
  font-weight: bold;

  &::after {
    content: 'x';
  }

  :hover {
    transform: scale(1.25);
  }
`;

export const CommandsWrapper = styled.div`
  flex: 1;
  display: grid;
  /* Grid responsivo: preenche colunas de ~150px. Em painel estreito cai pra
     1 coluna; largo, varias. Comandos (botoes) e setpoints (inputs) dividem
     o MESMO grid — cada controle ocupa um slot. align-items:start pra que
     uma celula de setpoint (label + input, mais alta) nao estique o botao
     vizinho. */
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  /* end: alinha os CONTROLES pelo fundo — o botao (sem label) fica no mesmo
     nivel do input do setpoint (que tem label em cima). Assim botao e input
     ficam na mesma linha de base, homogeneos. */
  align-items: end;
  grid-gap: 12px;
  margin: 8px 0 0 0;
  padding: 0;
`;

// Tres estados visuais:
//  - acionavel ($clickable): habilitado + destravado -> azul-soft, clicavel,
//    preenche no hover (affordance clara).
//  - bloqueado: habilitado mas com cadeado (locked) -> surface neutro, faint.
//  - analise ($analysis): comando DESABILITADO, exibido SO pra admin/Higra
//    revisar as posicoes/layout -> tracejado, read-only, com tag "analise".
// Comando desabilitado pra nao-admin nem renderiza (controlado no JSX).
export const Command = styled.div`
  display: ${(props) => (props.enabled || props.$analysis ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;

  button {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 44px;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 8px 12px;
    border-radius: 10px;
    transition: background 160ms ease, color 160ms ease, transform 160ms ease,
      border-color 160ms ease;
    cursor: ${(props) => (props.$clickable ? 'pointer' : 'not-allowed')};

    ${(props) =>
      props.$analysis
        ? `
          background: transparent;
          color: var(--cco-ink-faint);
          border: 1px dashed var(--cco-line-strong);
        `
        : props.$clickable
        ? `
          background: var(--cco-blue-soft);
          color: var(--cco-blue);
          border: 1px solid var(--cco-blue);
        `
        : `
          background: var(--cco-soft-surface);
          color: var(--cco-ink-faint);
          border: 1px solid var(--cco-line);
        `}

    ${(props) =>
      props.$clickable &&
      `&:hover { background: var(--cco-blue); color: #fff; transform: translateY(-1px); }`}
  }

  /* Tag "analise" — marca o comando read-only exibido so pra admin/Higra. */
  .tag {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.06em;
    padding: 1px 6px;
    border-radius: 999px;
    background: var(--cco-soft-surface);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink-faint);
    text-transform: lowercase;
  }
`;

// Legenda discreta pro admin/Higra quando ha comandos exibidos so pra analise.
export const CommandsHint = styled.p`
  margin: 8px 0 0;
  font-size: 11px;
  font-weight: 500;
  color: var(--cco-ink-faint);
  display: flex;
  align-items: center;
  gap: 6px;

  &::before {
    content: '';
    width: 16px;
    height: 0;
    border-top: 1px dashed var(--cco-line-strong);
    flex-shrink: 0;
  }
`;

export const HistoricTimelineWrapper = styled.div`
  flex: 4;
  display: flex;
  flex-direction: column;
  max-height: 58vh;
  overflow-y: auto;
`;

export const ContainerElements = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const HistoricTimelineCell = styled.div`
  display: flex;
  position: relative;
  border-left: 1px solid var(--cco-line);
  margin-left: 10px;
  padding-left: 30px;
  height: 100px;
  min-height: 100px;

  ::before {
    content: '.';
    color: transparent;
    top: 5px;
    left: -6px;
    width: 11px;
    height: 11px;
    position: absolute;
    border-radius: 50%;
    background: ${(props) =>
      props.executed ? 'var(--cco-green)' : 'var(--cco-red)'};
  }
`;

export const HistoricCellColumn = styled.div`
  display: flex;
  flex-direction: column;
  h3,
  span,
  > * {
    text-align: left;
  }
  h3 {
    color: var(--cco-ink-mute);
    font-size: 15px;
  }
  span {
    font-size: 18px;
    font-weight: 900;
    color: var(--cco-ink);
  }
  label {
    color: ${(props) =>
      props.executed ? 'var(--cco-green)' : 'var(--cco-red)'};
    font-size: 16px;
    font-weight: 800;
  }
`;

export const Line = styled.div`
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Dot = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  margin: 3px 10px;
  gap: 1rem;

  ::before {
    content: '.';
    color: transparent;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: ${(props) => (props.red ? 'var(--cco-red)' : 'var(--cco-green)')};
  }
`;

export const SetPointInputContainer = styled.div`
  /* Mesma altura e raio do botao de comando — homogeneidade no grid. */
  height: 44px;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: var(--cco-surface);
  color: var(--cco-ink);
  box-shadow: none;
  padding: 0 12px;
  width: 100%;
  text-overflow: ellipsis;
  border: 1px solid var(--cco-line);
  transition: border-color 150ms, box-shadow 150ms;

  /* Foco visivel — antes nao havia indicacao de qual campo estava ativo */
  &:focus-within {
    border-color: var(--cco-blue);
    box-shadow: 0 0 0 2px var(--cco-blue-soft);
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input {
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
    color: inherit;
    font-size: inherit;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
  }
`;
export const SetPointsContainer = styled.div`
  margin-top: 16px;
  display: grid;
  /* auto-fit + minmax: 1 ou 2 colunas conforme largura, em vez de 1fr 1fr
     fixo que quebra quando o painel direito esta estreito. */
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
`;

export const SetPointItem = styled.section`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: flex-end;
  gap: 6px;
  min-width: 0;

  > span {
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: var(--cco-ink-mute);
    line-height: 1.3;
  }
`;

export const PaginationContainer = styled.div`
  max-width: 400px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3rem auto;
`;

// Banner de comando pendente no dispositivo (shadow delta — rearme/habilitacao
// nao confirmados). Tom de atencao (laranja), discreto. So aparece quando ha
// pendencia real. Texto deixa claro que e nivel-dispositivo, nao os botoes V2.
export const PendingCommandBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background: var(--cco-orange-soft);
  border: 1px solid var(--cco-orange);
  color: var(--cco-orange);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;

  .ico {
    display: inline-flex;
    flex-shrink: 0;
    margin-top: 1px;
  }
  .txt {
    min-width: 0;
  }
`;

export const getModalStyles = (colors) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 102,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    width: '945px',
    backgroundColor: colors.card,
    borderColor: colors.disabled,
  },
});
